import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=2e372de2&scoped=true&"
import script from "./detailDialog.vue?vue&type=script&lang=js&"
export * from "./detailDialog.vue?vue&type=script&lang=js&"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=2e372de2&lang=less&scoped=true&"
import style1 from "./detailDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e372de2",
  null
  
)

export default component.exports